import React from 'react';
import './scss/App.scss';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './Components/ScrollToTop';

import Header from './Components/Header/Header';
import Portfolio from './Components/Portfolio/Portfolio';
import Home from './Components/Home/Home';
import Coaching from './Components/Coaching/Coaching';
import Contact from './Components/Contact/Contact';
import Coder from './Components/Coder/Coder';

import Cv from './Components/Cv/Cv';
import Footer from './Components/Footer/Footer';

import ReactGA from 'react-ga';
ReactGA.initialize('G-CLTPW2WX1R');
ReactGA.pageview(window.location.pathname + window.location.search);

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/resume" element={<Cv />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/coaching/coder" element={<Coder />} />
            <Route
              path="/kontakt"
              element={<Navigate to="/contact" replace />}
            />
            <Route
              path="/koučink"
              element={<Navigate to="/coaching" replace />}
            />
            <Route
              path="/koucink"
              element={<Navigate to="/coaching" replace />}
            />
            <Route
              path="/zivotopis"
              element={<Navigate to="/resume" replace />}
            />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
